<template>
  <tr
    class="participant-selector-row"
    @click="$emit('select-participant', user.id)"
  >
    <td class="participant-selector-col">
      <v-icon color="accent" right>
        {{ user.selected ? 'bhi-check-circle-filled' : 'bhi-ellipse' }}
      </v-icon>
    </td>
    <td class="participant-selector-col">
      <profile-preview-image
        :profileId="user.profileId"
        :uuid="user.uuid"
        :avatarSize="54"
        :avatarClasses="['participant-selector__avatar', 'avatar', 'rounded']"
        :thumbnailUrl="user.thumbnailUrl"
      />
    </td>
    <td class="participant-selector-col">
      <h4 class="participant-selector__name">
        {{ user.firstName }} {{ user.lastName }}
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span
      ><span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
  </tr>
</template>

<script>
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
export default {
  components: { ProfilePreviewImage },
  name: 'ParticipantSelectorTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
}
</script>

<style lang="scss">
.participant-selector {
  &__name {
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 54px;
    height: 54px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;
    cursor: pointer;
    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      width: 100%;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: left;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
